// will be updated by build scripts, DO NOT MODIFY!
const mochartVersion = "1.0.1";

export function getVersionString() {
  return mochartVersion;
}